import {Tool} from "../Config/Tool";
import {userStore} from "./userStore";
import {banksStore} from "./global";
import {thirdStore, walletStore} from "./third";
import {history} from "../history";
import {clearCache, dateStr, encrypt, fmtErr} from "./util";
import {tranTypeStore} from "./games";
import {channelStore} from "./channel";
import {betStore} from "./bet";
import {localStore, sessionStore} from "../storage";

function encPwd(s) {
    return encrypt(s, '90R1XU#DEDghEObz', '&$n$^VGfTT%VDdeX');
}

const version = 1.2
if (+localStore.getItem('app_version') !== version) {
    localStore.clear();
    sessionStore.clear();
    localStore.setItem('app_version', version)
}

function fmtD([start, end] = []) {
    return {
        start: dateStr(start, ' 00:00:00'),
        end: dateStr(end, ' 23:59:59'),
    }
}

/**
 *  t - cache time
 *  u - url
 *  p - is post
 *  done
 *  fail
 *  after
 *  before
 **/
const d = {
    // start(Y-m-d H:i:s) end(Y-m-d H:i:s) 运营数据
    '@opData': {u: 'agents/operational-data', before: fmtD},
    // 新会员注册
    '@regList': {u: 'agents/register'},
    // 会员充值
    '@disposeList': {u: 'agents/deposit'},
    // 会员首存
    '@firstDispose': {u: 'agents/first-deposit'},
    // start(Y-m-d H:i:s) end(Y-m-d H:i:s) 游戏汇总
    '@summary': {u: 'agents/game-summary', before: fmtD},
    '@token': {
        u: 'token',
        after({data: {token} = {}}) {
            if (!token) return {isSuccess: 0}
            userStore.tvTk = token
        }
    },
    '@getRecentGame': {
        u: 'games/recent-gaming-list',
        done(r) {
            const l = r && r.map(a => a.lottery_id);
            if (l && l.length) {
                betStore.recentGames.clear();
                betStore.recentGames.push(...l);
            }
        },
        t: 3e4
    },
    '@toAgent': {
        p: 1,
        u: 'agents/agent'
    },
    '@gameWay': {
        p: 1,
        u: 'games/method',
        t: 3e5,
    },
    '@getChargeRecord': {
        p: 0,
        t: 1e4,
        u: 'reports/transaction'
    },
    '@getChargeApply': {
        p: 0,
        t: 1e4,
        u: 'reports/deposit'
    },
    '@getWithDrawApply': {
        p: 0,
        t: 1e4,
        u: 'reports/withdrawal'
    },
    '@getTransType': {
        u: 'reports/transaction-type',
        t: 1e3 * 600,
        done(data) {
            if (tranTypeStore) tranTypeStore.data = data;
        }
    },
    '@activeList': {
        u: 'activities/list',
        t: 3e3
    },
    '@resetPwd': {
        u: 'users/reset-password',
        p: 1,
        before({password_old, password_new, type = 0}) {
            return {
                old_password: encPwd(password_old),
                password: encPwd(password_new),
                password_confirmation: encPwd(password_new),
                type
            }
        },
        done(a, {type}) {
            Tool.alert(type ? '资金密码更新成功！' : '个人密码修改成功！')
        },
        fail(err, {type}) {
            Tool.alert(fmtErr(err, type ? '资金密码更新失败，请稍后重试' : '个人密码修改失败,请稍后尝试。'))
        }
    },
    '@resetFound': {
        u: 'users/setfundpassword',
        p: 1,
        before({password_old, password_new}) {
            return {
                old_password: encPwd(password_old),
                password: encPwd(password_new),
                password_confirmation: encPwd(password_new),
                type: '1'
            }
        },
        after(res) {
            if (res && res.isSuccess) userStore.has_fund_password = 1;
        },
        done() {
            Tool.alert('资金密码设置成功！');
        },
        fail(err) {
            Tool.alert(fmtErr(err || '资金密码修改失败,请稍后尝试。'))
        }
    },
    '@applyActivity': {
        u: ({id}) => `activities/promo/${id}`,
        before: () => 0,
        done() {
            Tool.alert('领取成功');
        }
    },
    '@suggestions': {
        u: 'suggestions',
        p: 1,
        done() {
            Tool.alert('感谢您的反馈 !')
        }
    },
    '@unread': {
        u: 'message/unread-number',
        t: 5e3,
        done({count}) {
            userStore.unread = count;
        },
        fail() {
        }
    },
    '@init': {
        u: 'init',
        t: 1e4,
        done(data) {
            if (data) {
                data.allow_register = +data.allow_register || 0;
                Object.assign(userStore, data)
            }
        }
    },
    '@setUserInfo': {
        u: 'users/user-info',
        p: 1,
        after(r, p) {
            if (r && r.isSuccess)
                Object.assign(userStore, p);
        },
        done(a, p, c) {
            Tool.alert('个人信息更新成功')
            c('userSetting');
        }
    },
    '@traceDetail': {
        u: 'reports/trace-detail',
        t: 3e3
    },
    '@drop': {
        u: 'reports/project-drop',
        p: 1,
        done() {
            Tool.alert('撤单成功', () => {
                clearCache('betHistory');
            });
        }
    },
    '@getWays': {
        u: 'games/way',
        t: 1e100
    },
    '@article': {
        u: 'cms/article',
        p: 1,
        t: 1e3 * 60, //1min
    },
    '@regLinkUser': {
        u: 'agents/register-link-user',
        before(a) {
            if (a && !a.page_size) {
                a.page_size = 9999;
                return a;
            }
        },
        t: 5e3
    },
    '@transRec': {
        u: 'reports/transaction'
    },
    '@getIssue': {
        p: 1,
        t: 2e3,
        u: 'games/issue',
        fail() {
        }
    },
    '@getChannel': {
        t: 5e3,
        u: 'deposit/get-available-channel',
        done(data) {
            channelStore.channel = data
        },
        fail(e) {
            console.log(e);
            Tool.alert(fmtErr(e, '获取充值渠道异常'));
        }
    },
    '@aType': {
        u: 'activities/type',
        t: 2e3,
        done(a) {
            userStore.activeTypes = a.map(({id, name}) => [id, name])
        }
    },
    '@activities': {
        u: 'activities',
        after(a) {
            if (a && a.isSuccess)
                a.data.forEach(v => {
                    v.content = (v && v.content || '').replace(
                        /<a href="(https?:\/\/)?(game:\/\/.*?)".*?>(.*?)<\/a>/gi,
                        `<span class='link' onclick=window.open('$2')>$3</span>`)
                })
        },
        t: 6e4
    },
    '@contacts': {
        u: 'message/user-list'
    },
    '@getMsg': {
        u: 'message',
        t: 1e4,
    },
    '@msgView': {
        u: 'message/view',
    },
    '@delMsg': {
        p: 1,
        u: 'message/delete',
    },
    '@sendMsg': {
        u: 'message/create',
        p: 1,
        after(e) {
            if (e && e.status_code == 200) return {isSuccess: 1}
            return e
        },
        done() {
            Tool.alert('发送成功！');
        }
    },
    '@drawMoney': {
        u: 'withdraw/send-request',
        p: 1,
        before({amount, fund_password, id, is_usdt = 0}) {
            return {
                is_usdt,
                amount: amount,
                fund_password: encPwd(fund_password),
                id: id
            }
        }
    },
    '@withdrawCount': {
        u: 'withdraw/withdraw-count',
        p: 1,
        done({iWithdrawalNum = 0}) {
            userStore.today_withdraw = iWithdrawalNum
        }
    },
    '@balance': {
        clear: 1,
        u: 'users/available', done({available, withdrawable}) {
            userStore.available = available;
            userStore.withdrawable = withdrawable;
            walletStore.bls.main = {
                id: 'main',
                loading: 0,
                balance: +available || 0,
                load: () => walletStore.query('main'),
                name: walletStore.name('main')
            }
        }
    },
    '@thirdBalance': {
        clear: 1,
        t: 1e4,
        // u: 'third-party-game/balance',
        p: 1,
        fail() {
        },
    },
    '@getBanks': {
        clear: 1,
        t: 2e4,
        u: 'bankcard/getbanks',
        done(d) {
            if (d) banksStore.bankMap = d.data || []
        },
        fail(err) {
            Tool.alert(fmtErr(err, '获取银行卡列表失败'))
        }
    },
    '@userSetting': {
        clear: 1,
        t: ({user_id} = {}) => {
            if (user_id) return 0;
            return 5e3;
        },
        done(d, {user_id}) {
            if (!user_id) Object.assign(userStore, d)
        },
        u: 'agents/user-setting',
    },
    '@createAccount': {
        u: 'agents/accurate-create',
        p: 1
    },
    '@createLink': {
        u: 'agents/create-register-link',
        p: 1
    },
    '@getRegLinks': {
        u: 'agents/register-link',
        t: 2e3,
    },
    '@delLink': {
        u: 'agents/delete-register-link',
        p: 1
    },
    '@myBankCard': {
        t: 1e4,
        u: 'bankcard/mycard',
        done({banks, isLock}) {
            [].sort.call(banks || [], ({bank_id}) => {
                if (bank_id === 43) return 1;
                return -1
            });
            banksStore.myCard = banks;
            banksStore.isLock = isLock;
        }
    },
    // params  address
    '@addUsdt': {
        u: 'usdts',
        p: 1,
        done() {
            return ['@getUsdt']
        },
        fail(err) {
            Tool.alert(fmtErr(err, 'USDT钱包绑定失败,请稍后尝试。'));
        }
    },
    '@getUsdt': {
        u: 'usdts',
        t: 5e3,
        done(data) {
            if (data) data.forEach(a => {
                a.address = a.address.replace(/^.*?(.{4})$/g, '**** **** **** $1')
            });
            banksStore.usdts = data
        },
    },
    '@bindBank': {
        u: 'bankcard/bind-card',
        p: 1,
        done(d, p, c) {
            c('myBankCard')
        },
        fail(err) {
            Tool.alert(fmtErr(err, '银行卡绑定失败,请稍后尝试。'));
        }
    },
    '@verifyBank': {
        u: 'bankcard/validate-card',
        p: 1,
        before(data) {
            data.fund_password = encPwd(data.fund_password);
            return data
        },
        fail(err) {
            Tool.alert(fmtErr(err, '身份验证失败,请稍后尝试。'))
        }
    },
    '@verifyBank0': {
        u: 'bankcard/checking2',
        p: 1
    },
    '@thirdTrans': {
        u: 'third-party-game/transaction',
        p: 1,
        done() {
            Tool.alert("转账成功！");
        }
    },
    '@betHistory': {
        t: 5e3,
        u: 'reports/project',
    },
    '@betChase': {
        t: 5e3,
        u: 'reports/trace',
    },
    '@stopTrace': {
        u: 'reports/trace-stop',
        p: 1,
        done() {
            Tool.alert('取消成功');
        }
    },
    '@stopTraceDetail': {
        u: 'reports/trace-detail-cancel',
        p: 1,
        done() {
            Tool.alert('取消成功');
        }
    },
    '@thirdBetDetail': {
        t: 5e3,
        u: 'third-party-game/bet-detail',
        p: 1
    },
    '@getLottery': {
        u: 'games/lottery',
        t: 5e3,
        s: localStore,
    },
    '@thirdProduct': {
        u: 'third-party-game/product',
        t: 3e3,
        done(d) {
            thirdStore.initProducts(d);
        }
    },
    '@getPrize': {
        u: 'user-prize-set',
        done({banks = []}) {
            banksStore.myCard = banks;
        },
        t: 1e3 * 3600,
    },
    '@bonus': {
        u: 'agents/bonus'
    },
    '@commission': {
        u: 'agents/commission',
        p: 1
    },
    '@addBonus': {
        u: 'user-bonus-settings',
        p: 1,
        done() {
            Tool.alert('添加分红成功!');
        }
    },
    '@updateContracts': {
        u: ({user_id, id}) => `user-contracts/${user_id}/${id}`,
        before({status}) {
            return {status};
        },
        p: 2
    },
    '@delBonus': {
        u: ({id, user_id}) => `user-bonus-settings/${id}/${user_id}`,
        p: 3,
        before: () => 0,
        done() {
            Tool.alert('删除分红成功!');
        }
    },
    '@getBonus': {
        u: ({user_id}) => `user-bonus-settings/${user_id}`,
        before: () => 0,
    },
    '@setCtrBonus': {
        u: ({id}) => `contract-bonuses/sending/${id}`,
        p: 2,
        before: () => 0
    },
    '@getCtrBonuses': {
        u: 'contract-bonuses',
        t: 5e3
    },
    '@getTeamMg': {
        u: 'agents/team',
        after(d) {
            d.data = d.data || {}
            d.data.numbers = d.numbers;
        }
    },
    '@setPrizeGroup': {
        u: 'agents/set-prize-group',
        p: 1,
        done(d, {user_id}, clean) {
            Tool.alert('设置成功!');
            clean('userSetting', {user_id});
        }
    },
    '@getTeamACR': {
        u: 'reports/transaction',
        t: 1e4,
    },
    '@getTeamBAL': {
        u: 'agents/user-profit',
        t: 1e4,
        before(data) {
            if (data.page === 0) delete data.page
        },
    },
    '@transMoney': {
        u: 'agents/transfer',
        p: 1,
        before({username, amount, fund_password}) {
            return {
                username,
                amount,
                fund_password: fund_password,
            }
        },
        done() {
            Tool.alert('转账成功！');
            return ['@balance']
        }
    },
    '@getContracts': {
        t: 5e3,
        u: 'user-contracts',
        after(d) {
            d.data = d.data || {}
            d.data.numbers = d.numbers;
        },
        before(d) {
            d.page_size = 10;
        }
    },
    '@test': {
        u: 'test',
        before({domain}) {
            this.override.t = Date.now();
            this.override.domain = domain;
            return {t: Math.random()}
        },
        after(res) {
            return {isSuccess: res.status === 200, data: {t: Date.now() - this.override.t}}
        },
        fail() {
            return 1
        }
    },
    /**
     * 第三方游戏列表接口
     * @param product_type 产品类型
     * @param platform 平台类型
     * @param client_type 客户端类型
     * @param game_type 游戏类型
     * @param page 页码
     * @param page_size 每页条数
     * */
    '@thirdGames': {
        u: 'third-party-game/v2/list',
        t: 2e3,
        p: 1,
        after({isSuccess, data} = {}) {
            if (isSuccess && data) {
                return {
                    isSuccess,
                    data: data.data
                }
            } else {
                return {
                    isSuccess: false,
                    data: {
                        error: '返回数据空'
                    }
                }
            }
        },
        before(d) {
            let {game_type, product_type} = d;
            if (product_type !== 'ALL') {
                delete d.product_type;
                d.product_id = product_type;
            }
            if (game_type) {
                game_type = d.game_type = game_type.toUpperCase();
                const f = thirdStore.cate[game_type];
                if (f && f.filter && f.length) {
                    const fixKey = (a) => {
                        const k = a.split('_');
                        return k[0] + k.slice(1).map(v => v[0].toUpperCase() + v.substr(1)).join('')
                    }
                    this.override.fake = f.filter(v => {
                        const ks = Object.keys(d);
                        const df = ks.find(k => d[k] + '' !== v[fixKey(k)] + '');
                        return !df;
                    });
                }
                return {
                    is_pc: 0,
                    page: 1,
                    page_size: 9999999,
                    ...d
                }
            }
        },
        done(d, {game_type, product_type}) {
            if (product_type === 'ALL') thirdStore.cate[game_type] = d
        }
    },
    '@thirdLotteries': {
        u: 'third-party-game/lotteries',
        p: 1,
        t: 6e3
    },
    '@sms': {
        u: 'sms'
    },
    '@smsCheck': {
        u: 'sms/check',
        done(_, p) {
            if ('key' in p) return;
            Tool.alert('手机号码验证成功!');
            userStore.is_valid_phone = 1;
            history.back();
            return ['@userSetting']
        }
    },
    '@captcha': {
        u: 'users/captcha',
        t: 2e3,
        before(a = {}) {
            userStore.capLd = 1;
            a.key = userStore.capKey;
            if (a.useFor) {
                a.is_sign_up = 1;
                delete a['useFor'];
                a.key = localStore.seed;
            }
        },
        after() {
            userStore.capLd = 0;
        },
        done(a, p) {
            if (p.useFor) {
                userStore.regCode = a
            } else {
                userStore.captchaCode = a
            }
        }
    },
    '@roll': {
        u: 'roulette/lottery'
    },
    '@roulette': {
        u: 'roulette',
    },
    '@popAd':{
        u:'ad/pop-up-ads',
        // after(){
        //   return {
        //       isSuccess:true,
        //       data:[
        //           {
        //               title:'aaa',
        //               pic_url:'/icons_h5/AG/AV01.png',
        //               redirect_url:'xxxx'
        //           }
        //       ]
        //   }
        // },
        h(header,token){
            if(!token)delete header['Authorization']
        }
    }
};

Object.keys(d).forEach(k => {
    const o = d[k];
    const {u} = o;
    if (u) d['@/' + u] = o;
})

export const apiConfig = d;
